export class Verification {
  id: number;
  name: string;
  slug: string;
  site_id: number;
  code_verif: string;
}
